<template>
  <div>
    <el-cascader
      style="width: 100%"
      :options="options"
      v-model="value1"
      @change="handleChange"
      filterable
      :props="{ value: 'label' }"
      placeholder="省/市"
    ></el-cascader>
  </div>
</template>
 
<script>
// 第一步，先下载安装 npm install element-china-area-data -S
// 第二步，如下直接导入
import { provinceAndCityData } from "element-china-area-data";
export default {
  name: "index",
  props: ["value"],
  data() {
    return {
      options: provinceAndCityData,
      selectedOptions: [],
    };
  },
  computed: {
    value1: {
      set(val) {
        this.$emit("input", val);
      },
      get(val) {
        return this.value;
      },
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("provincesValueChang", value);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/common/cascader.vue